module.exports = __webpack_public_path__ + "static/img/mine3.c3b66a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine3.jpg
// module id = D9bS
// module chunks = 1